import { createFilterParams } from "./filterParams.js";
export function createUrl(page, rowsPerPage, dataListFilter, dataListSort, columnsSettings) {
  const pageSize = rowsPerPage ? `&pageSize=${rowsPerPage}` : "";

  let filterParams = createFilterParams(dataListFilter);
  if (!filterParams) {
    filterParams = "&filter=null";
  }

  let sortParams = "";
  if (dataListSort) {
    dataListSort.forEach((elem, index) => {
      sortParams += `&order.${elem.name}.isDesc=${elem.isDesc}&order.${elem.name
      }.order=${index + 1}`;
    });
  }

  const settingsParams = "";
  if (columnsSettings) {
    // columnsSettings.forEach((elem, index) => {
    //   settingsParams += `&settings.${elem.name}.isVisible=${elem.visible}&settings.${elem.name}.order=${index + 1}`;
    // });
  }

  return `${window.location.pathname}?page=${page}${pageSize}${filterParams}${sortParams}${settingsParams}`;
}